// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card-grid-container {
  display: flex;
  flex-direction: row;
  margin: auto;
  padding: 20px;
  flex-wrap: no-wrap;
  justify-content: center;
  animation: fadeIn 1s 8s ease-in-out forwards;
}

@media screen and (max-width: 1680px) {
  .card-grid-container {
    padding: 0px;
  }
}
.extra-space {
  width: 800px;
  height: 500px;
  background-color: black;
}

.service-overlay {
  position: absolute;
  top: 0;
  left: 0;
  background-color: rgba(29, 53, 87, 0.8);
  width: 100%;
  height: 100vh;
}

.contact-offer {
  display: flex;
  flex-direction: column;
  margin: 2em auto;
  font-family: "Spartan", sans-serif;
  color: #390879;
  width: 55em;
  align-items: center;
  font-size: 1em;
  font-weight: bold;
  cursor: pointer;
  box-sizing: inherit;
  -webkit-font-smoothing: antialiased;
  background-color: white;
  padding: 1em;
  border-radius: 4px;
  border: 1px solid rgba(0, 35, 70, 0.2);
  box-shadow: 0 2px 2px 0 rgba(0, 35, 70, 0.2);
}

.contact-offer:hover {
  z-index: 1;
  transform: translateY(-1px);
  box-shadow: 0 16px 64px 0 rgba(0, 35, 70, 0.2);
}

.card-service-title {
  display: flex;
  flex-direction: column;
  font-family: "Spartan", sans-serif;
  color: #a5e300;
  font-size: 50px;
  justify-content: center;
  align-items: center;
  padding: 50px;
  letter-spacing: 20px;
  opacity: 0;
  animation: fadeIn 1s 8s ease-in-out forwards;
}

@media screen and (max-width: 1680px) {
  .card-service-title {
    font-size: 35px;
    padding: 0px;
  }
}
/* Card Styles **/
.container {
  margin-top: 50px;
  padding: 40px 80px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
}

.offering-container {
  display: flex;
  flex-direction: column;
}

@media screen and (max-width: 1680px) {
  .container {
    padding: 40px 0;
  }
}
@media (max-width: 1280px) {
  .offering-container {
    margin: 2rem;
  }
}
.cardWrap {
  margin: 10px;
  transform: perspective(800px);
  transform-style: preserve-3d;
  cursor: pointer;
}

.cardWrap:hover .cardInfo {
  transform: translateY(0);
}

.cardWrap:hover .cardInfo p {
  opacity: 1;
}

.cardWrap:hover .cardInfo,
.cardWrap:hover .cardInfo p {
  transition: 0.6s cubic-bezier(0.23, 1, 0.32, 1);
}

.cardWrap:hover .cardInfo:after {
  transition: 5s cubic-bezier(0.23, 1, 0.32, 1);
  opacity: 1;
  transform: translateY(0);
}

.cardWrap:hover .cardBg {
  transition: 0.6s cubic-bezier(0.23, 1, 0.32, 1), opacity 5s cubic-bezier(0.23, 1, 0.32, 1);
  opacity: 0.8;
}

.cardWrap:hover .cardBg1 {
  transition: 0.6s cubic-bezier(0.23, 1, 0.32, 1), opacity 5s cubic-bezier(0.23, 1, 0.32, 1);
  opacity: 0.8;
}

.cardWrap:hover .cardBg2 {
  transition: 0.6s cubic-bezier(0.23, 1, 0.32, 1), opacity 5s cubic-bezier(0.23, 1, 0.32, 1);
  opacity: 0.8;
}

.cardWrap:hover .card {
  transition: 0.6s cubic-bezier(0.23, 1, 0.32, 1), box-shadow 2s cubic-bezier(0.23, 1, 0.32, 1);
  box-shadow: rgba(255, 255, 255, 0.2) 0 0 40px 5px, white 0 0 0 1px, rgba(0, 0, 0, 0.66) 0 30px 60px 0, inset #333 0 0 0 5px, inset white 0 0 0 6px;
}

.card {
  position: relative;
  flex: 0 0 240px;
  width: 250px;
  height: 420px;
  background-color: #333 !important;
  overflow: hidden;
  border-radius: 10px;
  box-shadow: rgba(0, 0, 0, 0.66) 0 30px 60px 0, inset #333 0 0 0 5px, inset rgba(255, 255, 255, 0.5) 0 0 0 6px;
  transition: 1s cubic-bezier(0.445, 0.05, 0.55, 0.95);
}

@media screen and (max-width: 1680px) {
  .card {
    width: 250px;
  }
}
.cardBg {
  background-image: url("https://ljc-site.s3.us-east-2.amazonaws.com/img/people-2.jpeg");
  opacity: 0.5;
  position: absolute;
  width: 100%;
  height: 100%;
  padding: 20px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  transition: 1s cubic-bezier(0.445, 0.05, 0.55, 0.95), opacity 5s 1s cubic-bezier(0.445, 0.05, 0.55, 0.95);
  pointer-events: none;
}

.cardBg1 {
  background-image: url("https://ljc-site.s3.us-east-2.amazonaws.com/img/store.png");
  opacity: 0.5;
  position: absolute;
  width: 100%;
  height: 100%;
  padding: 20px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  transition: 1s cubic-bezier(0.445, 0.05, 0.55, 0.95), opacity 5s 1s cubic-bezier(0.445, 0.05, 0.55, 0.95);
  pointer-events: none;
}

.cardBg2 {
  background-image: url("https://ljc-site.s3.us-east-2.amazonaws.com/img/speaking.png");
  opacity: 0.5;
  position: absolute;
  width: 100%;
  height: 100%;
  padding: 20px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  transition: 1s cubic-bezier(0.445, 0.05, 0.55, 0.95), opacity 5s 1s cubic-bezier(0.445, 0.05, 0.55, 0.95);
  pointer-events: none;
}

.cardTitle {
  font-size: 22px;
}

.cardInfo {
  padding: 20px;
  position: absolute;
  bottom: 0;
  width: 100%;
  color: #fff;
  transform: translateY(40%);
  transition: 0.6s 1.6s cubic-bezier(0.215, 0.61, 0.355, 1);
}

.cardInfo p {
  font-size: 1rem;
  opacity: 0;
  font-family: "Spartan", sans-serif;
  text-shadow: black 0 2px 3px;
  transition: 0.6s 1.6s cubic-bezier(0.215, 0.61, 0.355, 1);
}

.cardInfo * {
  position: relative;
  z-index: 1;
  font-family: "Spartan", sans-serif;
}

.cardInfo:after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  z-index: 0;
  width: 100%;
  height: 100%;
  background-image: linear-gradient(to bottom, transparent 0%, rgba(0, 0, 0, 0.8) 100%);
  background-blend-mode: overlay;
  opacity: 0;
  transform: translateY(100%);
  transition: 5s 1s cubic-bezier(0.445, 0.05, 0.55, 0.95);
}

.cardInfo h1 {
  font-family: "Spartan", sans-serif;
  font-size: 36px;
  font-weight: 700;
  text-shadow: rgba(0, 0, 0, 0.5) 0 10px 10px;
}

.offering-title {
  /* border-bottom: 5px solid white; */
  padding: 4px;
}

.offering-top-title {
  font-size: 20px;
  color: white;
  letter-spacing: 5px;
}

@media screen and (max-width: 1680px) {
  .offering-top-title {
    font-size: 15px;
  }
}
.arrow-icon {
  display: flex;
}

.service-arrow {
  animation: arrowServiceOut 1s 2s ease-in-out infinite;
}

@media (max-width: 1280px) {
  .srv-arrow {
    display: none !important;
  }
}
@media (max-width: 500px) {
  .card-grid-container {
    flex-wrap: wrap;
  }
  .contact-offer {
    width: 15em;
  }
}
@keyframes arrowServiceOut {
  0% {
    opacity: 0;
    transform: translateX(0px);
  }
  100% {
    opacity: 1;
    transform: translateX(50px);
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Service-Section/Service.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,uBAAA;EACA,4CAAA;AACF;;AAEA;EACE;IACE,YAAA;EACF;AACF;AAEA;EACE,YAAA;EACA,aAAA;EACA,uBAAA;AAAF;;AAGA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,uCAAA;EACA,WAAA;EACA,aAAA;AAAF;;AAGA;EACE,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,kCAAA;EACA,cAAA;EACA,WAAA;EACA,mBAAA;EACA,cAAA;EACA,iBAAA;EACA,eAAA;EACA,mBAAA;EACA,mCAAA;EACA,uBAAA;EACA,YAAA;EACA,kBAAA;EACA,sCAAA;EACA,4CAAA;AAAF;;AAGA;EACE,UAAA;EACA,2BAAA;EACA,8CAAA;AAAF;;AAGA;EACE,aAAA;EACA,sBAAA;EACA,kCAAA;EACA,cAAA;EACA,eAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,oBAAA;EACA,UAAA;EACA,4CAAA;AAAF;;AAGA;EACE;IACE,eAAA;IACA,YAAA;EAAF;AACF;AAGA,iBAAA;AAEA;EACE,gBAAA;EACA,kBAAA;EAEA,aAAA;EACA,eAAA;EAEA,6BAAA;AAFF;;AAKA;EACE,aAAA;EACA,sBAAA;AAFF;;AAKA;EACE;IACE,eAAA;EAFF;AACF;AAKA;EACE;IACE,YAAA;EAHF;AACF;AAMA;EACE,YAAA;EAEA,6BAAA;EAEA,4BAAA;EACA,eAAA;AAJF;;AAOA;EAEE,wBAAA;AAJF;;AAOA;EACE,UAAA;AAJF;;AAOA;;EAGE,+CAAA;AAJF;;AAOA;EAEE,6CAAA;EACA,UAAA;EAEA,wBAAA;AAJF;;AAOA;EAGE,0FAAA;EAEA,YAAA;AANF;;AASA;EAGE,0FAAA;EAEA,YAAA;AARF;;AAWA;EAGE,0FAAA;EAEA,YAAA;AAVF;;AAaA;EAGE,6FAAA;EAEA,kJAAA;AAZF;;AAiBA;EACE,kBAAA;EAEA,eAAA;EACA,YAAA;EACA,aAAA;EACA,iCAAA;EACA,gBAAA;EACA,mBAAA;EACA,6GAAA;EAGA,oDAAA;AAfF;;AAiBA;EACE;IACE,YAAA;EAdF;AACF;AAiBA;EACE,sFAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,4BAAA;EACA,2BAAA;EACA,sBAAA;EAGA,yGAAA;EAEA,oBAAA;AAjBF;;AAoBA;EACE,kFAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,4BAAA;EACA,2BAAA;EACA,sBAAA;EAGA,yGAAA;EAEA,oBAAA;AAnBF;;AAsBA;EACE,qFAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,4BAAA;EACA,2BAAA;EACA,sBAAA;EAGA,yGAAA;EAEA,oBAAA;AArBF;;AAwBA;EACE,eAAA;AArBF;;AAwBA;EACE,aAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EAEA,0BAAA;EAEA,yDAAA;AArBF;;AAwBA;EACE,eAAA;EACA,UAAA;EACA,kCAAA;EACA,4BAAA;EAEA,yDAAA;AArBF;;AAwBA;EACE,kBAAA;EACA,UAAA;EACA,kCAAA;AArBF;;AAwBA;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EAQA,qFAAA;EAKA,8BAAA;EACA,UAAA;EAEA,2BAAA;EAEA,uDAAA;AA/BF;;AAkCA;EACE,kCAAA;EACA,eAAA;EACA,gBAAA;EACA,2CAAA;AA/BF;;AAkCA;EACE,oCAAA;EACA,YAAA;AA/BF;;AAkCA;EACE,eAAA;EACA,YAAA;EACA,mBAAA;AA/BF;;AAkCA;EACE;IACE,eAAA;EA/BF;AACF;AAkCA;EACE,aAAA;AAhCF;;AAmCA;EACE,qDAAA;AAhCF;;AAmCA;EACE;IACE,wBAAA;EAhCF;AACF;AAmCA;EACE;IACE,eAAA;EAjCF;EAmCA;IACE,WAAA;EAjCF;AACF;AAoCA;EACE;IACE,UAAA;IACA,0BAAA;EAlCF;EAqCA;IACE,UAAA;IACA,2BAAA;EAnCF;AACF","sourcesContent":[".card-grid-container {\n  display: flex;\n  flex-direction: row;\n  margin: auto;\n  padding: 20px;\n  flex-wrap: no-wrap;\n  justify-content: center;\n  animation: fadeIn 1s 8s ease-in-out forwards;\n}\n\n@media screen and (max-width: 1680px) {\n  .card-grid-container {\n    padding: 0px;\n  }\n}\n\n.extra-space {\n  width: 800px;\n  height: 500px;\n  background-color: black;\n}\n\n.service-overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  background-color: rgba(29, 53, 87, 0.8);\n  width: 100%;\n  height: 100vh;\n}\n\n.contact-offer {\n  display: flex;\n  flex-direction: column;\n  margin: 2em auto;\n  font-family: \"Spartan\", sans-serif;\n  color: #390879;\n  width: 55em;\n  align-items: center;\n  font-size: 1em;\n  font-weight: bold;\n  cursor: pointer;\n  box-sizing: inherit;\n  -webkit-font-smoothing: antialiased;\n  background-color: white;\n  padding: 1em;\n  border-radius: 4px;\n  border: 1px solid rgba(0, 35, 70, 0.2);\n  box-shadow: 0 2px 2px 0 rgba(0, 35, 70, 0.2);\n}\n\n.contact-offer:hover {\n  z-index: 1;\n  transform: translateY(-1px);\n  box-shadow: 0 16px 64px 0 rgba(0, 35, 70, 0.2);\n}\n\n.card-service-title {\n  display: flex;\n  flex-direction: column;\n  font-family: \"Spartan\", sans-serif;\n  color: #a5e300;\n  font-size: 50px;\n  justify-content: center;\n  align-items: center;\n  padding: 50px;\n  letter-spacing: 20px;\n  opacity: 0;\n  animation: fadeIn 1s 8s ease-in-out forwards;\n}\n\n@media screen and (max-width: 1680px) {\n  .card-service-title {\n    font-size: 35px;\n    padding: 0px;\n  }\n}\n\n/* Card Styles **/\n\n.container {\n  margin-top: 50px;\n  padding: 40px 80px;\n  display: -webkit-box;\n  display: flex;\n  flex-wrap: wrap;\n  -webkit-box-pack: center;\n  justify-content: space-around;\n}\n\n.offering-container {\n  display: flex;\n  flex-direction: column;\n}\n\n@media screen and (max-width: 1680px) {\n  .container {\n    padding: 40px 0;\n  }\n}\n\n@media (max-width: 1280px) {\n  .offering-container {\n    margin: 2rem;\n  }\n}\n\n.cardWrap {\n  margin: 10px;\n  -webkit-transform: perspective(800px);\n  transform: perspective(800px);\n  -webkit-transform-style: preserve-3d;\n  transform-style: preserve-3d;\n  cursor: pointer;\n}\n\n.cardWrap:hover .cardInfo {\n  -webkit-transform: translateY(0);\n  transform: translateY(0);\n}\n\n.cardWrap:hover .cardInfo p {\n  opacity: 1;\n}\n\n.cardWrap:hover .cardInfo,\n.cardWrap:hover .cardInfo p {\n  -webkit-transition: 0.6s cubic-bezier(0.23, 1, 0.32, 1);\n  transition: 0.6s cubic-bezier(0.23, 1, 0.32, 1);\n}\n\n.cardWrap:hover .cardInfo:after {\n  -webkit-transition: 5s cubic-bezier(0.23, 1, 0.32, 1);\n  transition: 5s cubic-bezier(0.23, 1, 0.32, 1);\n  opacity: 1;\n  -webkit-transform: translateY(0);\n  transform: translateY(0);\n}\n\n.cardWrap:hover .cardBg {\n  -webkit-transition: 0.6s cubic-bezier(0.23, 1, 0.32, 1),\n    opacity 5s cubic-bezier(0.23, 1, 0.32, 1);\n  transition: 0.6s cubic-bezier(0.23, 1, 0.32, 1),\n    opacity 5s cubic-bezier(0.23, 1, 0.32, 1);\n  opacity: 0.8;\n}\n\n.cardWrap:hover .cardBg1 {\n  -webkit-transition: 0.6s cubic-bezier(0.23, 1, 0.32, 1),\n    opacity 5s cubic-bezier(0.23, 1, 0.32, 1);\n  transition: 0.6s cubic-bezier(0.23, 1, 0.32, 1),\n    opacity 5s cubic-bezier(0.23, 1, 0.32, 1);\n  opacity: 0.8;\n}\n\n.cardWrap:hover .cardBg2 {\n  -webkit-transition: 0.6s cubic-bezier(0.23, 1, 0.32, 1),\n    opacity 5s cubic-bezier(0.23, 1, 0.32, 1);\n  transition: 0.6s cubic-bezier(0.23, 1, 0.32, 1),\n    opacity 5s cubic-bezier(0.23, 1, 0.32, 1);\n  opacity: 0.8;\n}\n\n.cardWrap:hover .card {\n  -webkit-transition: 0.6s cubic-bezier(0.23, 1, 0.32, 1),\n    box-shadow 2s cubic-bezier(0.23, 1, 0.32, 1);\n  transition: 0.6s cubic-bezier(0.23, 1, 0.32, 1),\n    box-shadow 2s cubic-bezier(0.23, 1, 0.32, 1);\n  box-shadow: rgba(255, 255, 255, 0.2) 0 0 40px 5px, white 0 0 0 1px,\n    rgba(0, 0, 0, 0.66) 0 30px 60px 0, inset #333 0 0 0 5px,\n    inset white 0 0 0 6px;\n}\n\n.card {\n  position: relative;\n  -webkit-box-flex: 0;\n  flex: 0 0 240px;\n  width: 250px;\n  height: 420px;\n  background-color: #333 !important;\n  overflow: hidden;\n  border-radius: 10px;\n  box-shadow: rgba(0, 0, 0, 0.66) 0 30px 60px 0, inset #333 0 0 0 5px,\n    inset rgba(255, 255, 255, 0.5) 0 0 0 6px;\n  -webkit-transition: 1s cubic-bezier(0.445, 0.05, 0.55, 0.95);\n  transition: 1s cubic-bezier(0.445, 0.05, 0.55, 0.95);\n}\n@media screen and (max-width: 1680px) {\n  .card {\n    width: 250px;\n  }\n}\n\n.cardBg {\n  background-image: url(\"https://ljc-site.s3.us-east-2.amazonaws.com/img/people-2.jpeg\");\n  opacity: 0.5;\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  padding: 20px;\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: cover;\n  -webkit-transition: 1s cubic-bezier(0.445, 0.05, 0.55, 0.95),\n    opacity 5s 1s cubic-bezier(0.445, 0.05, 0.55, 0.95);\n  transition: 1s cubic-bezier(0.445, 0.05, 0.55, 0.95),\n    opacity 5s 1s cubic-bezier(0.445, 0.05, 0.55, 0.95);\n  pointer-events: none;\n}\n\n.cardBg1 {\n  background-image: url(\"https://ljc-site.s3.us-east-2.amazonaws.com/img/store.png\");\n  opacity: 0.5;\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  padding: 20px;\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: cover;\n  -webkit-transition: 1s cubic-bezier(0.445, 0.05, 0.55, 0.95),\n    opacity 5s 1s cubic-bezier(0.445, 0.05, 0.55, 0.95);\n  transition: 1s cubic-bezier(0.445, 0.05, 0.55, 0.95),\n    opacity 5s 1s cubic-bezier(0.445, 0.05, 0.55, 0.95);\n  pointer-events: none;\n}\n\n.cardBg2 {\n  background-image: url(\"https://ljc-site.s3.us-east-2.amazonaws.com/img/speaking.png\");\n  opacity: 0.5;\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  padding: 20px;\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: cover;\n  -webkit-transition: 1s cubic-bezier(0.445, 0.05, 0.55, 0.95),\n    opacity 5s 1s cubic-bezier(0.445, 0.05, 0.55, 0.95);\n  transition: 1s cubic-bezier(0.445, 0.05, 0.55, 0.95),\n    opacity 5s 1s cubic-bezier(0.445, 0.05, 0.55, 0.95);\n  pointer-events: none;\n}\n\n.cardTitle {\n  font-size: 22px;\n}\n\n.cardInfo {\n  padding: 20px;\n  position: absolute;\n  bottom: 0;\n  width: 100%;\n  color: #fff;\n  -webkit-transform: translateY(40%);\n  transform: translateY(40%);\n  -webkit-transition: 0.6s 1.6s cubic-bezier(0.215, 0.61, 0.355, 1);\n  transition: 0.6s 1.6s cubic-bezier(0.215, 0.61, 0.355, 1);\n}\n\n.cardInfo p {\n  font-size: 1rem;\n  opacity: 0;\n  font-family: \"Spartan\", sans-serif;\n  text-shadow: black 0 2px 3px;\n  -webkit-transition: 0.6s 1.6s cubic-bezier(0.215, 0.61, 0.355, 1);\n  transition: 0.6s 1.6s cubic-bezier(0.215, 0.61, 0.355, 1);\n}\n\n.cardInfo * {\n  position: relative;\n  z-index: 1;\n  font-family: \"Spartan\", sans-serif;\n}\n\n.cardInfo:after {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 0;\n  width: 100%;\n  height: 100%;\n  background-image: -webkit-gradient(\n    linear,\n    left top,\n    left bottom,\n    from(transparent),\n    to(rgba(0, 0, 0, 0.8))\n  );\n  background-image: linear-gradient(\n    to bottom,\n    transparent 0%,\n    rgba(0, 0, 0, 0.8) 100%\n  );\n  background-blend-mode: overlay;\n  opacity: 0;\n  -webkit-transform: translateY(100%);\n  transform: translateY(100%);\n  -webkit-transition: 5s 1s cubic-bezier(0.445, 0.05, 0.55, 0.95);\n  transition: 5s 1s cubic-bezier(0.445, 0.05, 0.55, 0.95);\n}\n\n.cardInfo h1 {\n  font-family: \"Spartan\", sans-serif;\n  font-size: 36px;\n  font-weight: 700;\n  text-shadow: rgba(0, 0, 0, 0.5) 0 10px 10px;\n}\n\n.offering-title {\n  /* border-bottom: 5px solid white; */\n  padding: 4px;\n}\n\n.offering-top-title {\n  font-size: 20px;\n  color: white;\n  letter-spacing: 5px;\n}\n\n@media screen and (max-width: 1680px) {\n  .offering-top-title {\n    font-size: 15px;\n  }\n}\n\n.arrow-icon {\n  display: flex;\n}\n\n.service-arrow {\n  animation: arrowServiceOut 1s 2s ease-in-out infinite;\n}\n\n@media (max-width: 1280px) {\n  .srv-arrow {\n    display: none !important;\n  }\n}\n\n@media (max-width: 500px) {\n  .card-grid-container {\n    flex-wrap: wrap;\n  }\n  .contact-offer {\n    width: 15em;\n  }\n}\n\n@keyframes arrowServiceOut {\n  0% {\n    opacity: 0;\n    transform: translateX(0px);\n  }\n\n  100% {\n    opacity: 1;\n    transform: translateX(50px);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
